// state
import axios from "axios";
import commonservice from "../../shared/common.service";

const defaultState = () => ({
	entity: {
		id: null,
		noOfPerson: null,
		firstName: null,
		lastName: null,
		email: null,
		address: null,
		countryName: null,
		mobile: null,
		arrivalDate: null,
		departureDate: null,
		airlines: null,
		flightNo: null,
		flightTime: null,
		airportPickup: null,
		modeOfPayment: null,
		otherSpecify: null,
		contentName: null,
		status: null,
		response: null,
		createdDate: null,
		modifiedDate: null,
	},
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
	loadBooking({}, { pagination, search }) {
		return new Promise((resolve, reject) => {
			var param = {
				descending:
					pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : true,
				page: pagination.page,
				rowsPerPage: pagination.itemsPerPage,
				sortBy:
					pagination.sortBy.length > 0 ? pagination.sortBy[0] : "createdDate",
				search: search,
			};
			axios
				.get("/booking?" + commonservice.convertToQueryString(param))
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	setBooking({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.get("/booking/" + id)
				.then((response) => {
					commit("SET_BOOKING", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	saveBooking({ commit, state }) {
		return new Promise((resolve, reject) => {
			if (state.entity.id) {
				axios
					.patch("/booking", {
						id: state.entity.id,
						response: state.entity.response,
					})
					.then(
						(response) => {
							commit("RESET");
							resolve(response);
						},
						(error) => {
							reject(error);
						}
					)
					.catch((error) => {
						reject(error);
					});
			}
		});
	},
	deleteBooking({ commit }, { id }) {
		return new Promise((resolve, reject) => {
			axios
				.delete("/booking/" + id)
				.then((response) => {
					commit("RESET");
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};

// mutations
const mutations = {
	RESET(state) {
		Object.assign(state, defaultState());
	},
	SET_BOOKING_DATA(state, data) {
		if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
			state[data.key][data.index][data.property] = data.value;
		} else if (
			Object.prototype.toString.call(state[data.key]) === "[object Object]"
		) {
			state[data.key][data.property] = data.value;
		} else state.entity[data.key] = data.value;
	},
	SET_BOOKING(state, data) {
		state.entity.id = data.id;
		state.entity.noOfPerson = data.noOfPerson;
		state.entity.firstName = data.firstName;
		state.entity.lastName = data.lastName;
		state.entity.email = data.email;
		state.entity.address = data.address;
		state.entity.countryName = data.countryName;
		state.entity.mobile = data.mobile;
		state.entity.arrivalDate = data.arrivalDate;
		state.entity.departureDate = data.departureDate;
		state.entity.airlines = data.airlines;
		state.entity.flightNo = data.flightNo;
		state.entity.flightTime = data.flightTime;
		state.entity.airportPickup = data.airportPickup;
		state.entity.modeOfPayment = data.modeOfPayment;
		state.entity.otherSpecify = data.otherSpecify;
		state.entity.contentName = data.contentName;
		state.entity.status = data.status;
		state.entity.response = data.response;
		state.entity.createdDate = data.createdDate;
		state.entity.modifiedDate = data.modifiedDate;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
